import capitalize from '@/helpers/capitalize'
import {http} from '@/axios'
import {blockScroll, unBlockScroll} from '@/helpers/scroll'

export default {
  computed: {
    paginationStyle() {
      if (this.pending) {
        return {
          pointerEvents: 'none',
          opacity: '0.5'
        }
      }

      return null
    },
    filterSelectedProperties() {
      const result = this.filtersKeys.reduce((result, key) => {
        const values = this[createFiltersName(key)]

        if (values.length) {
          result[key] = values
        }

        return result
      }, {})

      return result
    },
  },
  methods: {
    load() {
      this.pending = true

      const params = {
        page: this.$route.query.page || 1,
        ...this.filterSelectedProperties
      }

      http.get(this.apiLink, {
        params
      }).then(({data}) => {
        // console.log('history', data)
        this.items = data.data.data
        this.filters = data.filters
        this.pagesQuantity = data.data.last_page
      }).catch(error => {
        this.error = {
          code: error.response.status,
          message: error.response.data && error.response.data.message || error.message
        }
      }).finally(() => {
        this.pending = false
      })
    },
    isChecked([key, valueId]) {
      const values = this[createFiltersName(key)]

      return values.some(value => {
        return Number(value) === Number(valueId)
      })
    },
    onToggleFilter([key, valueId]) {
      const values = [...(this.filterSelectedProperties[key] || [])]

      const valueIndex = values.findIndex(value => {
        return Number(value) === Number(valueId)
      })

      if (valueIndex >= 0) {
        values.splice(valueIndex, 1)
      } else {
        values.push(valueId)
      }

      const query = JSON.parse(JSON.stringify(this.filterSelectedProperties))

      if (values.length) {
        query[key] = values
      } else {
        delete query[key]
      }

      for (const key in query) {
        query[key] = query[key].join('|')
      }

      this.$router.push({
        query
      })
    },

    onClear(key) {
      const query = JSON.parse(JSON.stringify(this.$route.query))
      delete query[key]

      this.$router.push({
        query
      })
    },

    onOpenFilterMob() {
      blockScroll()
      this.showFilterMob = true
    },
    onCloseFilterMob() {
      unBlockScroll()
      this.showFilterMob = false
    },
  },
  created() {
    this.load()
  },
  watch: {
    '$route.query'() {
      this.load()
    }
  },
}

function createFiltersName(key) {
  const name = key.split('_').reduce((result, item) => {
    return result + capitalize(item)
  }, '')

  return 'filters' + name
}

export function getComputedProperties(filtersKeys) {
  return filtersKeys.reduce((result, key) => {
    result[createFiltersName(key)] = function () {
      const r = this.$route.query[key]
      return r ? r.split('|') : []
    }

    return result
  }, {})
}
